// extracted by mini-css-extract-plugin
export default {"feature":"Feature__feature___Vi6Tj","header":"Feature__header___IpTLt","illo":"Feature__illo___w2s8j"};